module.exports = __webpack_public_path__ + "media/images/evlka-8d8907284293ebd71b3f66e588c87a99.png";